import { Document } from 'app/rm/erp/common/document/model/document';
import { JobApplication } from 'app/rm/erp/jobapplication/model/jobapplication';

export class JobApplicationAndDocuments {

    constructor( readonly application: JobApplication = new JobApplication(),
        readonly documents: Document[] = [],
        public privacyPolicyAccepted: boolean = false ) { }
}
